import { useEffect } from 'react';
import { globalShortcutsService } from '../services/globalShortcutsService';
import { useSlimCreatePaletteStore } from '../stores/slimCreatePaletteStore';

/**
 * Cmd+K opens the expanded ("center") Quick Actions palette — the same
 * open/create/ask surface as the system-bar Sparkle icon and canvas
 * Cmd/Ctrl-click, just wider and vertically centered. Replaces the old
 * GlobalEntitySearch modal (now unwired — see useGlobalEntitySearchShortcut,
 * left in place but unused).
 *
 * Registered at the default priority (0) so contextual_ai_selection
 * (priority 100, useGlobalCmdKShortcut) still wins Cmd+K whenever there's a
 * live in-app text/cell selection.
 */
export const useQuickActionsCenterShortcut = () => {
  useEffect(() => {
    globalShortcutsService.register({
      id: 'quick_actions_center',
      key: 'k',
      modifiers: { cmd: true },
      description: 'Open Quick Actions',
      handler: () => {
        useSlimCreatePaletteStore.getState().open({
          screenPos: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
          placement: 'center',
        });
      },
    });

    return () => globalShortcutsService.unregister('quick_actions_center');
  }, []);
};
